import { Button, Popconfirm, TableProps } from "antd";
import {
  IBettingWebsiteContacts,
  IBettingWebsiteRating,
} from "../../types/BettingWebsite";
import { IBettingWebsiteFeature } from "../../types/BettingWebsite.Feature";
import { IBettingWebsiteLanguage } from "../../types/BettingWebsite.Language";
import { IBettingWebsitePaymentGatway } from "../../types/BettingWebsite.PaymentGateway";
import { RatingBreakdownPopover } from "./Components/Popovers/BettingWebsiteRatesPopover";
import { ContactsPopover } from "./Components/Popovers/BettingWebsiteContactsPopover";
import { LanguagesPopover } from "./Components/Popovers/BettingWebsiteLanguagePopover";
import { PaymentGatewaysPopover } from "./Components/Popovers/BettingWebsitePaymentGateway";
import { FeaturesPopover } from "./Components/Popovers/BettingWebsiteFeaturesPopover";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { CiTrash } from "react-icons/ci";
import { TbImageInPicture } from "react-icons/tb";

export type BettingWebsiteTableType = {
  id: string;
  en: string;
  ar: string;
  fr: string;
  rates?: IBettingWebsiteRating;
  contacts?: IBettingWebsiteContacts;
  languages: IBettingWebsiteLanguage[];
  paymentgateways: IBettingWebsitePaymentGatway[];
  features: IBettingWebsiteFeature[];
  image?: string;
};

export const BettingWebsitesColumns = (
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<BettingWebsiteTableType>["columns"] => [
  {
    title: "Title",
    children: [
      {
        title: "English",
        dataIndex: "en",
        key: "en",
      },
      {
        title: "Arabic",
        dataIndex: "ar",
        key: "ar",
      },
      {
        title: "French",
        dataIndex: "fr",
        key: "fr",
      },
    ],
  },

  {
    title: "Rates",
    dataIndex: "rates",
    key: "Rates",
    render: (_, record) => (
      <RatingBreakdownPopover
        id={record.id}
        page={page}
        pageSize={pageSize}
        rating={record.rates}
      />
    ),
  },
  {
    title: "Contacts",
    dataIndex: "contacts",
    key: "contacts",
    render: (_, record) => (
      <ContactsPopover
        id={record.id}
        page={page}
        pageSize={pageSize}
        contacts={record.contacts}
      />
    ),
  },
  {
    title: "Languages",
    dataIndex: "languages",
    key: "languages",
    render: (_, record) => (
      <LanguagesPopover
        id={record.id}
        page={page}
        pageSize={pageSize}
        languages={record.languages}
      />
    ),
  },
  {
    title: "Payment Gateway",
    dataIndex: "paymentgateways",
    key: "paymentgateways",
    render: (_, record) => (
      <PaymentGatewaysPopover
        id={record.id}
        page={page}
        pageSize={pageSize}
        gateways={record.paymentgateways}
      />
    ),
  },
  {
    title: "Features",
    dataIndex: "features",
    key: "features",
    render: (_, record) => (
      <FeaturesPopover
        id={record.id}
        page={page}
        pageSize={pageSize}
        features={record.features}
      />
    ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/betting-websites/edit/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Link
          to={`/betting-websites/edit-image/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<TbImageInPicture />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this feature?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];
